const googleNewsSelector = (state) => state.googleNews.googleNews

export { googleNewsSelector }
